import { render, staticRenderFns } from "./SingleDecoratedGroup.vue?vue&type=template&id=1f9ea7e0"
import script from "./SingleDecoratedGroup.vue?vue&type=script&lang=js"
export * from "./SingleDecoratedGroup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports